import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import Swal from "sweetalert2";
import { environment } from "../../../environments/environment";

export interface TarjetaOperacion {
  placa: string;
  idVehiculo: any;
  numero: number;
  expedicion: Date | null;
  vencimiento: Date | null;
}

@Injectable({
  providedIn: "root",
})
export class TarjetaOperacionService {
  private apiUrl =  `${environment.apiUrl}/api/tarjetas`; 
  //private apiUrl = "http://localhost:3000/api/tarjetas";

  constructor(private http: HttpClient) {}

  getTarjetas(): Observable<TarjetaOperacion[]> {
    return this.http.get<TarjetaOperacion[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  getTarjetaByNumero(id: number): Observable<TarjetaOperacion> {
    return this.http.get<TarjetaOperacion>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(
        catchError(() => {
          return throwError(() => new Error("Tarjeta de operación no encontrada."));
        })
      );
  }

  createTarjeta(tarjeta: TarjetaOperacion): Observable<TarjetaOperacion> {
    return this.http.post<TarjetaOperacion>(this.apiUrl, tarjeta, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  updateTarjeta(id: number, tarjeta: any): Observable<any> {
    if (!id || isNaN(id)) {
      return throwError(() => new Error("Número de tarjeta inválido"));
    }

    return this.http.put(`${this.apiUrl}/${id}`, tarjeta, { withCredentials: true })
      .pipe(
        map((response: any) => {
          if (response?.message === "No se realizaron cambios en la tarjeta de operación") {
            Swal.fire({
              icon: "info",
              title: "Sin cambios",
              text: "No se realizaron modificaciones en la tarjeta de operación.",
            });
            return throwError(() => new Error("No se realizaron cambios."));
          }
          return response;
        }),
        catchError(this.handleError)
      );
  }

  deleteTarjeta(numero_tarjeta: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${numero_tarjeta}`, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  updateEstadoToCero(numero: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/estado/${numero}`, {}, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  getTarjetasPlaca(placa: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/placa/${placa}`, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  private handleError(error: any) {
    console.error("Ocurrió un error:", error);
    let message = "Error en la solicitud.";

    if (error.status) {
      switch (error.status) {
        case 400:
          message = error.error?.message || "Solicitud incorrecta.";
          break;
        case 401:
          message = "No autorizado. Verifica tu sesión.";
          break;
        case 403:
          message = "Acceso prohibido. No tienes permisos suficientes.";
          break;
        case 404:
          message = "Tarjeta de operación no encontrada.";
          break;
        case 500:
          message = "Error interno del servidor.";
          break;
        default:
          message = `Error inesperado: ${error.statusText || error.message}`;
          break;
      }
    }

    return throwError(() => new Error(message));
  }
}
